export const STORAGE_KEYS = {
  AUTH_DATA: 'authData',
  SELECTED_CID: 'selectedCId',
  SELECTED_INGESTCFG: 'selectedIngestcfgId',
  SELECTED_PLAYER_ID: 'selectedPlayerId',
  /** Set by the 401 handler so the login page can explain the forced sign-out. */
  SESSION_EXPIRED: 'sessionExpired',
} as const;
